__webpack_require__.p = "https://assets-01.periodica.press/ae7e479-21515489524/";